import { render } from "./DialogCompletion.vue?vue&type=template&id=4c88d79e"
import script from "./DialogCompletion.vue?vue&type=script&lang=js"
export * from "./DialogCompletion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__